/*
 * Notification step 3 demo (snippets/mogrt-demo-notification.liquid), run by
 * assets/mogrt-steps-demo.js: the banner slides in as the template comes,
 * the header and the body are typed into the panel (which scrolls on from
 * one to the other) and change on the banner as they're typed, Message Box
 * Color and Opacity turn it solid orange, it holds and slides back up.
 */
(() => {
  const placeholders = ['Header text', 'Body text'];
  // the placeholders in the shop's language, from the banner's data-i18n-* (English above as the fallback)
  const placeholder = (note, i) => [note.dataset.i18nHeader, note.dataset.i18nBody][i] || placeholders[i] || '';
  const mirrored = new WeakSet();

  const parts = (screen) => {
    const note = screen.querySelector('[data-mdn-note]');
    return {
      note,
      fields: [...screen.querySelectorAll('[data-eg-text]')],
      lines: [...note.querySelectorAll('[data-mdn-line]')],
    };
  };

  // the banner shows what's in the panel's fields, letter by letter
  const mirror = (p) => {
    if (mirrored.has(p.note)) return;
    mirrored.add(p.note);
    p.fields.forEach((field, i) => {
      const line = p.lines[i];
      if (!line) return;
      new MutationObserver(() => (line.textContent = field.textContent)).observe(field, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
  };

  // the panel scrolls on by one group, so Body Text sits where Header Text was
  const scroll = (screen, on) => {
    const heads = screen.querySelectorAll('.eg-panel .eg-head');
    const by = heads.length > 1 ? heads[1].offsetTop - heads[0].offsetTop : 0;
    if (by > 0) screen.style.setProperty('--mdn-scroll', `${-by}px`);
    screen.toggleAttribute('data-mdn-scroll', on);
  };

  // armed: out of sight above the line; in: slides down; out: slides back up
  const place = (note, state) => {
    note.toggleAttribute('data-armed', state === 'armed');
    note.toggleAttribute('data-in', state === 'in' || state === 'out');
    note.toggleAttribute('data-out', state === 'out');
  };

  window.MogrtDemos = window.MogrtDemos || {};
  window.MogrtDemos.notification = {
    rest(screen) {
      const p = parts(screen);
      mirror(p);
      p.fields.forEach((field, i) => {
        field.dataset.full = field.dataset.full || field.textContent.trim();
        field.textContent = field.dataset.full;
        field.classList.remove('is-typing');
        if (p.lines[i]) p.lines[i].textContent = field.dataset.full;
      });
      screen.setAttribute('data-live', '');
      scroll(screen, true);
      place(p.note, 'in');
    },
    async pass(screen, t) {
      const p = parts(screen);
      // the template as it comes, waiting above the frame; the panel at its top
      place(p.note, 'armed');
      scroll(screen, false);
      p.fields.forEach((field, i) => (field.textContent = placeholder(p.note, i)));
      p.note.getBoundingClientRect();
      if (!(await t.wait(500))) return false;
      place(p.note, 'in');
      if (!(await t.wait(1100))) return false;
      if (!(await t.type(p.fields[0], p.fields[0].dataset.full, { speed: 80 }))) return false;
      // scroll on to Body Text and Message Box
      scroll(screen, true);
      if (!(await t.wait(600))) return false;
      if (!(await t.type(p.fields[1], p.fields[1].dataset.full, { speed: 55 }))) return false;
      t.live(true);
      if (!(await t.wait(3000))) return false;
      place(p.note, 'out');
      return t.wait(1100);
    },
  };
})();
